var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1042 6.66699V6.00033C13.1042 5.26366 12.5075 4.66699 11.7708 4.66699H8.79417C8.5715 4.66699 8.36283 4.55566 8.2395 4.37033L7.30217 2.96433C7.17817 2.77833 6.97017 2.66699 6.7475 2.66699H3.77083C3.03417 2.66699 2.4375 3.26366 2.4375 4.00033V12.569C2.4375 12.9917 2.7795 13.3337 3.20217 13.3337V13.3337C3.5395 13.3337 3.8375 13.1123 3.93417 12.789L5.4855 7.61766C5.65483 7.05299 6.17417 6.66699 6.76283 6.66699H13.3235C14.2135 6.66699 14.8535 7.52166 14.6028 8.37566L13.4288 12.3757C13.2622 12.9437 12.7415 13.3337 12.1495 13.3337H3.20217",
    stroke: "#001A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.dd633ee2a801dfd076245945740f5350.svg";
export { ForwardRef as ReactComponent };